export default "__VITE_ASSET__y$NVdFJj__"